// Initialize swiper slider component only if not already initialized
function initializeSwiperSlider() {
  if (typeof Swiper === "undefined") {
    setTimeout(initializeSwiperSlider, 100);
    return;
  }

  // Initialize main swiper slider
  const mainSlider = document.getElementById("main-swiper-slider");
  if (mainSlider && !mainSlider.swiper) {
    const mainPagination = mainSlider.querySelector(".swiper-pagination");
    if (mainPagination) {
      new Swiper(mainSlider, {
        spaceBetween: 30,
        slidesPerView: 4,
        pagination: {
          el: mainPagination,
          type: "progressbar",
        },
        renderProgressbar: function (progressbarFillClass) {
          return '<span class="' + progressbarFillClass + '"></span>';
        },
        allowTouchMove: true,
        watchSlidesProgress: true,
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
      });
    }
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", initializeSwiperSlider);

// Also try on window load as backup
window.addEventListener("load", initializeSwiperSlider);
